{
  "nav": {
    "home": "Home",
    "silos": "Silos",
    "skills": "Skills",
    "arena": "Arena",
    "aiPowered": "Alimentato da IA",
    "knowledgeFlows": "La conoscenza scorre in modo intelligente attraverso la tua organizzazione.",
    "askTheKnowledgeBase": "Interroga la base di conoscenze",
    "ask": "Chiedi",
    "help": "Aiuto",
    "logout": "Esci",
    "signIn": "Accedi",
    "openProfileInMe": "Il tuo profilo in JoyIA Me"
  },
  "common": {
    "loading": "Caricamento...",
    "error": "Errore",
    "save": "Salva",
    "saving": "Salvataggio...",
    "cancel": "Annulla",
    "delete": "Elimina",
    "edit": "Modifica",
    "hide": "Nascondi",
    "create": "Crea",
    "search": "Cerca",
    "filter": "Filtra",
    "refresh": "Aggiorna",
    "close": "Chiudi",
    "back": "Indietro",
    "next": "Successivo",
    "previous": "Precedente",
    "submit": "Invia",
    "confirm": "Conferma",
    "yes": "Sì",
    "no": "No",
    "all": "Tutti",
    "none": "Nessuno",
    "select": "Seleziona",
    "viewAll": "Visualizza tutto",
    "remove": "Rimuovi",
    "add": "Aggiungi",
    "new": "Nuovo",
    "success": "Successo",
    "warning": "Avviso",
    "info": "Informazioni",
    "noResults": "Nessun risultato trovato",
    "noData": "Gestisci i tuoi silo di conoscenza e cerca in tutti i contenuti",
    "clear": "Cancella",
    "sync": "Sincronizza",
    "item": "elemento",
    "items": "elementi",
    "copied": "Copiato!"
  },
  "silos": {
    "title": "Silos",
    "description": "Silos di conoscenza e raccolte di documenti",
    "createNew": "Crea nuovo Silo",
    "editSilo": "Modifica Silo",
    "deleteSilo": "Elimina Silo",
    "siloSettings": "Impostazioni Silo",
    "knowledge": "Conoscenza",
    "project": "Progetto",
    "timeline": "Cronologia",
    "sync": "Sincronizza",
    "syncHistory": "Cronologia sincronizzazione",
    "connectors": "Connettori",
    "statusLabel": "Stato",
    "idle": "Inattivo",
    "running": "In esecuzione",
    "pending": "In sospeso",
    "error": "Errore",
    "newSilo": "Nuovo Silo",
    "createSilo": "Crea Silo",
    "myKnowledgeBase": "La mia knowledge base",
    "sortByName": "Nome (A–Z)",
    "sortByCreated": "Creati di recente",
    "heading": "Silos di conoscenza",
    "unitSingular": "silo",
    "searchPlaceholder": "Cerca silos...",
    "emptyTitle": "Nessun silo di conoscenza",
    "emptyBody": "Crea il tuo primo silo per iniziare a costruire la tua knowledge base"
  },
  "skills": {
    "title": "Skills",
    "description": "Competenze e capacità",
    "createNew": "Crea nuova competenza",
    "editSkill": "Modifica competenza",
    "deleteSkill": "Elimina competenza",
    "arena": "Arena",
    "skillDetails": "Dettagli competenza",
    "knowledge": "Conoscenza",
    "project": "Progetto",
    "mine": "Le mie Skills",
    "unitSingular": "skill",
    "newSkill": "Nuova Skill",
    "searchPlaceholder": "Cerca skills…",
    "allCategories": "Tutte le categorie",
    "emptyTitle": "Nessuna skill trovata",
    "emptyBody": "Crea la tua prima skill o importane una da GitHub o skills.sh",
    "sharedWithTribes": "Condivise con le Tribe",
    "thisTribeHint": "Skill condivise con questa Tribe. Apri una skill per vedere le istruzioni di installazione.",
    "sharedTribesHint": "Skill condivise con le Tribe di cui fai parte. Apri una skill per vedere le istruzioni di installazione.",
    "showAllTribes": "Mostra tutte le mie Tribe",
    "loadFailed": "Impossibile caricare le skill. Ricarica la pagina.",
    "sharedEmptyBody": "Qui non sono ancora stati condivisi skill. Chiedi a un membro del tribe di condividerne uno.",
    "categoryEmptyBody": "Nessuno skill corrisponde alla categoria «{{category}}».",
    "allSkills": "Tutti gli skill",
    "collections": "Raccolte di skill",
    "allSources": "Tutte le fonti",
    "source": "Fonte",
    "noMatchesBody": "Prova una ricerca diversa o rimuovi i filtri.",
    "clearFilters": "Rimuovi filtri"
  },
  "visibility": {
    "private": "Privato",
    "privateDesc": "Solo tu puoi accedere",
    "orgVisible": "Visibile all'organizzazione",
    "orgVisibleDesc": "Chiunque nella tua organizzazione",
    "restricted": "Limitato",
    "restrictedDesc": "Persone che inviti",
    "tribe": "Tribe",
    "tribeDesc": "Tutti i membri di una tribe",
    "label": "Visibilità",
    "public": "Pubblico"
  },
  "classification": {
    "unclassified": "Non classificato",
    "confidential": "Riservato",
    "strictlyConfidential": "Strettamente riservato"
  },
  "sources": {
    "github": "GitHub",
    "internal": "Interno",
    "skillSh": "skills.sh"
  },
  "ask": {
    "title": "Chiedi",
    "askAboutThisSilo": "Fai domande su questo silo… (Invio per inviare)",
    "askAcrossAllSilos": "Fai domande su tutti i silos… (Invio per inviare)",
    "askAboutKnowledgeflow": "Fai domande su Knowledgeflow… (Invio per inviare)",
    "askAQuestion": "Fai una domanda su questa base di conoscenze...",
    "phAsk": "Chiedi su tutti i silos… (Invio per inviare, Maiusc+Invio per una nuova riga)",
    "synthesised": "Le risposte sono sintetizzate dai silos di conoscenza a cui hai accesso, tramite ricerca basata sull'IA"
  },
  "settings": {
    "movedToMe": "Il tuo profilo si trova ora in JoyIA Me. Ti stiamo reindirizzando…",
    "movedToMeNoUrl": "Il tuo profilo si trova ora in JoyIA Me."
  },
  "errors": {
    "loadingFailed": "Caricamento non riuscito",
    "saveFailed": "Salvataggio non riuscito",
    "deleteFailed": "Eliminazione non riuscita",
    "invalidInput": "Input non valido",
    "unauthorized": "Non sei autorizzato",
    "notFound": "Non trovato",
    "serverError": "Errore del server",
    "failed": "Non riuscito: {{message}}"
  },
  "forms": {
    "required": "Obbligatorio",
    "optional": "Opzionale",
    "selectOne": "Seleziona uno...",
    "selectMultiple": "Seleziona più di uno...",
    "enterText": "Immetti testo...",
    "enterNumber": "Immetti un numero...",
    "chooseFile": "Scegli file...",
    "dragDropFiles": "Trascina e rilascia i file qui",
    "or": "o",
    "browseFiles": "sfoglia file",
    "description": "Descrizione"
  },
  "pagination": {
    "previous": "Precedente",
    "next": "Successivo",
    "of": "di",
    "page": "Pagina",
    "rowsPerPage": "Righe per pagina"
  },
  "dialogs": {
    "confirmDelete": "Conferma eliminazione",
    "areYouSure": "Sei sicuro di voler eliminare questo elemento?",
    "thisCannotBeUndone": "Questa azione non può essere annullata.",
    "deleteConfirm": "Elimina"
  },
  "empty": {
    "noSilos": "Nessun silo ancora",
    "noSkills": "Nessuna competenza ancora",
    "noResults": "Nessun risultato trovato"
  },
  "home": {
    "searchPlaceholder": "Cerca in tutti i silos...",
    "noSearchResults": "Nessun risultato",
    "totalItems": "Elementi totali",
    "totalMembers": "Membri totali",
    "recentSilos": "Silos recenti",
    "noSilos": "Nessun silo.",
    "createOne": "Creane uno",
    "recentItems": "Elementi di conoscenza recenti",
    "knowledgeHealth": "Stato della conoscenza",
    "noItemsFromSource": "Nessun elemento da questa origine"
  },
  "siloView": {
    "abstractSaved": "Riassunto salvato",
    "abstractSaveFailed": "Salvataggio del riassunto non riuscito: {{message}}",
    "siloUpdated": "Silo aggiornato",
    "siloUpdateFailed": "Aggiornamento silo non riuscito: {{message}}",
    "syncFailed": "Impossibile avviare la sincronizzazione: {{message}}",
    "generatingAbstractBackground": "Generazione del riassunto in corso…",
    "abstractDrafted": "Riassunto bozza — rileggi e salva",
    "abstractGenerateFailed": "Generazione del riassunto non riuscita: {{message}}",
    "editSilo": "Modifica silo",
    "members": "Membri",
    "config": "Configurazione",
    "syncHistory": "Cronologia sincronizzazione",
    "treeView": "Visualizzazione albero",
    "mergeSilo": "Unisci silo",
    "triggerSync": "Avvia sincronizzazione ora",
    "syncing": "Sincronizzazione in corso…",
    "abstractPlaceholder": "Scrivi un breve riassunto di cosa contiene questo silo...",
    "editAbstract": "Modifica riassunto",
    "regenerateWithAI": "Rigenera con IA",
    "generatingAbstract": "Generazione del riassunto in corso…",
    "addSummary": "+ Aggiungi un riassunto per questo silo...",
    "generate": "Genera",
    "generateWithAI": "Genera riassunto con IA",
    "cliSetupInstructions": "Istruzioni di configurazione CLI",
    "itemsInSilo": "{{count}} elementi in questo silo",
    "cliProjectSilo": "Silo di progetto guidato da CLI",
    "linkSiloToProject": "Collega questo silo a una directory di progetto in modo che i tuoi agenti IA possano leggere e scrivere durante lo sviluppo.",
    "step1": "1. Collega al tuo progetto",
    "runInProjectDir": "Esegui questo nella directory del tuo progetto per collegare questo silo.",
    "step2": "2. Sincronizza i file del tuo progetto",
    "syncDescription": "Acquisisce il contesto del tuo progetto (README, docs, config) in questo silo. Idempotente — i file non modificati vengono saltati.",
    "step3": "3. Invia una singola nota",
    "pushDescription": "Aggiunge un elemento. Entrambi gli argomenti sono obbligatori — o invia un file come contenuto:",
    "step4": "4. Usa con agenti IA",
    "aiAgentsDescription": "Una volta collegato, gli agenti di codifica IA (Claude Code, OpenCode, ecc.) possono accedere automaticamente alle conoscenze di questo silo tramite il server MCP.",
    "state_active": "Attivo",
    "state_paused": "In pausa",
    "state_archived": "Archiviato",
    "lastSync": "Ultima sincronizzazione: {{time}}",
    "syncOverdue": "Sincronizzazione scaduta",
    "nextSync": "Prossima sincronizzazione tra {{label}}",
    "source": "Origine",
    "sortNewest": "Più recenti prima",
    "sortImportance": "Massima importanza",
    "sortAccessed": "Più acceduti",
    "noItemsYet": "Nessun elemento di conoscenza ancora",
    "noItemsHelp": "Aggiungi elementi manualmente o configura le fonti di sincronizzazione",
    "noItemsOfType": "Nessun elemento di tipo {{type}} trovato",
    "clearFilter": "Cancella filtro",
    "mergeDialog": "Unisci un altro silo in questo",
    "mergeDescription": "Tutti gli elementi dal silo selezionato verranno spostati in {{name}}.",
    "sourceSilo": "Silo di origine",
    "selectSiloMerge": "Seleziona un silo da cui unire...",
    "deleteSourceAfterMerge": "Elimina il silo di origine dopo l'unione",
    "mergeSuccess": "Unione di {{count}} elementi completata con successo.{{deleted}}",
    "mergeFailed": "Unione non riuscita: {{message}}",
    "merging": "Unione in corso...",
    "merge": "Unisci",
    "editSiloDialog": "Modifica silo",
    "tags": "Tag (separati da virgola)",
    "publicSilo": "Silo pubblico",
    "publicSiloDescription": "Tutti gli utenti della tua organizzazione possono leggere questo silo",
    "guardrailProfiles": "Profili guardrail",
    "guardrailDescription": "Applicato a tutte le chiamate LLM che elaborano i contenuti di questo silo",
    "linkToProject": "Collega a un progetto (CLI)",
    "linkSharedSilo": "Collega questo come silo condiviso",
    "attachSiloDescription": "Allega questo silo a una directory di progetto come {{role}}, insieme al silo principale del progetto. Collegamento di sola lettura — gli agenti IA possono leggerlo, ma le scritture vanno al silo principale del progetto.",
    "timelineSiloLabel": "un silo \"timeline\" condiviso (attività recente)",
    "knowledgeSiloLabel": "un silo \"conoscenza\" condiviso",
    "linkLimits": "Un progetto può collegare un silo principale più fino a 5 soli in lettura (uno di conoscenza, uno di timeline, più silos aggiuntivi in sola lettura).",
    "healthAllClear": "Salute della conoscenza: tutto libero",
    "avgImportance": "Importanza media: {{value}}",
    "staleItem": "elemento",
    "staleItems": "elementi",
    "conflict": "conflitto",
    "multiConflicts": "conflitti",
    "archiveStale": "Archivia {{count}} elementi scaduti",
    "archiveConfirm": "Archiviare {{count}} elementi?",
    "runInProjectDirLabel": "Esegui nella directory del progetto",
    "staleItemsLabel": "elementi",
    "staleItemsList": "{{count}} elementi scaduti {{type}}",
    "archivedStale": "{{count}} elementi obsoleti archiviati",
    "conflicts": "{{count}} {{type}}"
  },
  "siloHealth": {
    "authExpiredTitle": "Un connettore non riesce più ad accedere",
    "authExpiredBody": "Le credenziali salvate per {{sources}} sono scadute — in genere perché la password dell'account collegato è stata modificata. Finché la sorgente non viene ricollegata, nessun nuovo contenuto raggiunge questo silo.",
    "syncFailingTitle": "Un connettore non riesce a sincronizzare",
    "syncFailingBody": "L'ultima sincronizzazione di {{sources}} è fallita, quindi nessun nuovo contenuto raggiunge questo silo.",
    "openSyncSettings": "Apri le impostazioni di sincronizzazione",
    "unindexedTitle": "Il contenuto di questo silo non è ricercabile",
    "thinTitle": "Solo una parte di questo silo è ricercabile",
    "coverageBody": "{{indexed}} di {{total}} elementi sono nell'indice di ricerca ({{pct}}%). Le domande poste a questo silo — anche da un sito web collegato — riceveranno risposta solo da quella parte, senza che venga segnalato alcun errore.",
    "rebuildIndex": "Ricostruisci l'indice nelle impostazioni di sincronizzazione"
  },
  "chart": {
    "noData": "Nessun dato da mostrare",
    "fullscreen": "Schermo intero",
    "expandedFullscreen": "Grafico espanso a schermo intero",
    "closeFullscreen": "Chiudi schermo intero"
  },
  "apps": {
    "title": "App e origini",
    "description": "Sfoglia gli elementi di conoscenza in base all'origine che li ha creati",
    "noItems": "Nessun elemento di conoscenza",
    "lastUsed": "Ultimo utilizzo"
  },
  "skillShare": {
    "title": "Condividi Skill",
    "description": "Scegli chi può vedere e installare questa skill.",
    "visibilitySet": "Visibilità impostata su {{value}}",
    "updateFailed": "Impossibile aggiornare la visibilità: {{message}}",
    "selectTribes": "Seleziona le tribù che possono vedere questa skill",
    "noTribes": "Nessuna tribù disponibile",
    "selectAtLeastOne": "Seleziona almeno una tribù per salvare"
  },
  "skillDetail": {
    "installTracked": "Installazione registrata",
    "refreshedWithFiles": "Aggiornato — {{count}} nuovo file raggruppato{{plural}} dalla fonte",
    "refreshedFiles": "Aggiornato dalla fonte — {{count}} file",
    "refreshedFromSource": "Aggiornato dalla fonte",
    "skillDeleted": "Skill eliminata",
    "skillUpdated": "Skill aggiornata",
    "share": "Condividi",
    "refreshing": "Aggiornamento in corso…",
    "refresh": "Aggiorna",
    "skillNotFound": "Skill non trovata",
    "backToSkills": "Torna a Skills",
    "public": "Pubblico",
    "sharedWithTribe": "Condiviso con tribe",
    "private": "Privato",
    "installs": "installazioni",
    "skillAdded": "Skill aggiunta!",
    "wantToTestInArena": "Vuoi vedere come si comporta nell'Arena?",
    "testInArena": "Prova nell'Arena",
    "editSkill": "Modifica skill",
    "name": "Nome",
    "version": "Versione",
    "description": "Descrizione",
    "content": "Contenuto",
    "categories": "Categorie",
    "extraTags": "Tag aggiuntivi",
    "commaSeparated": "separati da virgole",
    "tagsPlaceholder": "swiftui, performance",
    "visibility": "Visibilità",
    "saving": "Salvataggio…",
    "saveChanges": "Salva le modifiche",
    "pluginCapabilities": "Funzionalità del plugin",
    "providesTools": "Fornisce strumenti",
    "dependencies": "Dipendenze",
    "readinessCheck": "Verifica di idoneità",
    "requiredEnvironment": "Ambiente richiesto",
    "required": "Richiesto",
    "nightWatchHooks": "Hook Night Watch",
    "notEvaluatedYet": "Non ancora valutato",
    "runThroughArena": "Esegui questa skill attraverso l'arena per valutare quanto bene un modello la segue.",
    "runArenaTest": "Esegui test arena",
    "arenaScore": "Punteggio Arena",
    "testAgain": "Prova di nuovo",
    "evaluations": "valutazione",
    "lastTested": "ultimo test",
    "hideHistory": "Nascondi la cronologia",
    "showAllEvaluations": "Mostra tutte le {{count}} valutazioni",
    "useThisSkill": "Usa questa skill",
    "files": "file",
    "copyCommand": "Copia il comando",
    "writesSKillMd": "Scrive SKILL.md più",
    "bundledFile": "file incluso",
    "copyingGivesYou": "— copiando il contenuto sottostante ottieni solo SKILL.md.",
    "copySKillMd": "Copia SKILL.md",
    "tracking": "Tracciamento…",
    "trackInstall": "Registra l'installazione",
    "preferredJoyiaCli": "Preferito — Joyia CLI",
    "setup": "Configurazione",
    "copy": "Copia",
    "opensInteractiveSkillBrowser": "Apre il browser di skills interattivo. Premi",
    "toInstall": "per installare.",
    "installsFromSkillsSh": "Installa da skills.sh — non è richiesto un account Joyia.",
    "installFromJoyiaMarketplace": "Installa dal marketplace Joyia per ID.",
    "manualInstall": "Installazione manuale (senza Joyia CLI)",
    "install": "Installa",
    "cliTab": "CLI",
    "personalTab": "Personale",
    "projectTab": "Progetto",
    "npxSkillsInstall": "npx skills install",
    "npxSkillsAdd": "npx skills add",
    "step1AddMarketplace": "Step 1 — aggiungi marketplace",
    "step2InstallPlugin": "Step 2 — installa plugin",
    "copyJSON": "Copia JSON",
    "skillContent": "Contenuto della skill",
    "copyRaw": "Copia il testo grezzo",
    "noContent": "_Nessun contenuto_",
    "bundledFiles": "File inclusi",
    "alongsideSKillMd": "accanto a SKILL.md",
    "collapse": "Comprimi",
    "expand": "Espandi",
    "deleting": "Eliminazione in corso…",
    "confirmDelete": "Conferma eliminazione"
  },
  "sharepoint": {
    "connected": "Connesso a Microsoft SharePoint",
    "signInFailed": "Accesso non riuscito",
    "completingSignIn": "Completamento dell'accesso a Microsoft…",
    "redirecting": "Connesso — reindirizzamento in corso…",
    "error": "Accesso non riuscito",
    "backToSilos": "Torna ai Silos"
  },
  "auth": {
    "subtitle": "Memoria persistente per i tuoi agenti AI e i tuoi flussi di lavoro di sviluppo",
    "signInWithPia": "Accedi con PIA"
  },
  "askPanel": {
    "search": "Cerca",
    "ask": "Chiedi",
    "searchFailed": "Ricerca non riuscita",
    "failedToGetAnswer": "Impossibile ottenere la risposta",
    "semanticSearchPlaceholder": "Ricerca semantica...",
    "focusInTree": "Metti a fuoco nell'albero",
    "askPlaceholder": "Fai una domanda su questa knowledge base...",
    "answer": "Risposta",
    "sources": "Fonti"
  },
  "skillsArena": {
    "title": "Arena delle Competenze",
    "description": "Testa e confronta le competenze — i risultati sono salvati e classificati",
    "evaluateLabel": "Valuta una Competenza",
    "selectSkill": "Seleziona una competenza dal catalogo o dalla classifica qui sotto per valutarla.",
    "testPromptLabel": "Prompt di Test",
    "testPromptPlaceholder": "Inserisci un prompt di test...",
    "evaluating": "Valutazione in corso... (potrebbe richiedere 30-60s)",
    "evaluateButton": "Valuta Competenza",
    "scoreMax": "Punteggio / 100",
    "adherenceMax": "Aderenza / 10",
    "duration": "Durata",
    "criteria": "Criteri",
    "generatedOutput": "Output Generato",
    "model": "Modello",
    "judge": "Giudice",
    "savedToRankings": "Salvato nella classifica",
    "viewInLibrary": "Visualizza in Libreria",
    "skillCatalog": "Catalogo Competenze",
    "rankings": "Classifiche",
    "searchCatalog": "Cerca nel catalogo...",
    "noSkillsMatch": "Nessuna competenza corrisponde ai tuoi filtri.",
    "noEvaluations": "Nessuna valutazione ancora",
    "runFirstEvaluation": "Esegui la tua prima valutazione dell'Arena per iniziare a costruire la classifica.",
    "skill": "Competenza",
    "avgScore": "Punteggio Medio",
    "tests": "Test",
    "lastRun": "Ultimo Esecuzione",
    "librarySkill": "Competenza di Libreria"
  },
  "itemView": {
    "itemSaved": "Elemento salvato",
    "failedToSave": "Salvataggio non riuscito",
    "memoryArchived": "Memoria archiviata",
    "memoryRestoredToActive": "Memoria ripristinata come attiva",
    "memoryPaused": "Memoria in pausa — nascosta dalla ricerca",
    "failedToUpdateState": "Aggiornamento dello stato non riuscito",
    "itemDeleted": "Elemento eliminato",
    "failedToDelete": "Eliminazione non riuscita",
    "staleWarning": "Questo elemento potrebbe essere obsoleto — contrassegnato come scadente dalla manutenzione",
    "conflictDetected": "Conflitto rilevato",
    "viewConflictingItem": "visualizza elemento in conflitto",
    "conflictResolved": "Conflitto risolto — entrambi gli elementi conservati",
    "keepBoth": "Mantieni Entrambi",
    "conflictResolvedOtherArchived": "Conflitto risolto — altro elemento archiviato",
    "keepThisArchiveOther": "Mantieni Questo, Archivia Altro",
    "thisItemArchived": "Questo elemento è stato archiviato",
    "archiveThis": "Archivia Questo",
    "tagsLabel": "Tag (separati da virgola)",
    "tagsPlaceholder": "tag1, tag2",
    "contentLabel": "Contenuto",
    "relatedMemories": "Memorie correlate",
    "deleteItemTitle": "Eliminare questo elemento?",
    "deleteItemDescription": "Questa azione non può essere annullata. L'elemento di conoscenza e tutto il suo contenuto verranno rimossi in modo permanente.",
    "deleting": "Eliminazione in corso...",
    "projectLabel": "Progetto",
    "typeLabel": "Tipo",
    "statusLabel": "Stato",
    "priorityLabel": "Priorità",
    "assigneeLabel": "Assegnato a",
    "versionLabel": "Versione",
    "summarised": "Riassunto",
    "used": "Utilizzato",
    "timesSingular": "volta",
    "timesPlural": "volte",
    "moreOptions": "Altre opzioni",
    "restoreToActive": "Ripristina come Attivo",
    "pause": "Pausa",
    "archive": "Archivia"
  },
  "syncHistory": {
    "heading": "Cronologia sincronizzazione",
    "backToSilo": "Torna al Silo",
    "noJobs": "Nessun processo di sincronizzazione ancora",
    "cancelled": "Sincronizzazione annullata — il batch corrente terminerà poi si arresterà",
    "finalising": "Finalizzazione in corso…",
    "sourcePagesTip": "Pagine di origine scansionate — non è lo stesso che aggiungere elementi al silo",
    "src": "src",
    "itemsCreatedTip": "Nuovi elementi aggiunti al silo",
    "itemsUpdatedTip": "Elementi esistenti aggiornati",
    "itemsSkippedTip": "Elementi non modificati saltati",
    "itemsDeletedTip": "Elementi rimossi dal silo",
    "stopSync": "Arresta sincronizzazione",
    "jobId": "ID processo",
    "parentSync": "Sincronizzazione principale",
    "triggeredBy": "Attivato da",
    "duration": "Durata",
    "since": "Da",
    "sinceLower": "da",
    "items": "Elementi",
    "new": "nuovo",
    "updated": "aggiornato",
    "unchanged": "non modificato",
    "deleted": "eliminato",
    "refused": "Rifiutati",
    "fileNotIndexed": "file non indicizzato",
    "files": "file non indicizzati",
    "labelled": "etichettati",
    "error": "errore",
    "errors": "errori",
    "retrying": "Nuovo tentativo in corso…",
    "retry": "Riprova",
    "finalisingDetail": "Finalizzazione in corso — verifica che nessun'altra pagina rimanga, quindi chiude il processo…",
    "scanningSource": "Scansione origine in corso…",
    "sourcePages": "pagine di origine",
    "sourcePageNote": "Pagine di origine scansionate ≠ elementi aggiunti. I conteggi degli elementi (+nuovo ~aggiornato =non modificato) si accumulano al completamento di ogni batch.",
    "processing": "Elaborazione in corso…",
    "starting": "Avvio in corso… in attesa del primo batch",
    "waitingForWorker": "In attesa che il worker ritiri il processo…",
    "stoppedBy": "Interrotto da {{user}} — le pagine già acquisite vengono mantenute",
    "user": "utente"
  },
  "newSkill": {
    "skillCreated": "Competenza \"{name}\" creata",
    "skillImported": "Importata \"{name}\"",
    "noSkillFilesFound": "Nessun file di competenza .md trovato in questo repository",
    "couldNotQueryGitHub": "Impossibile interrogare GitHub",
    "couldNotFetchSkill": "Impossibile recuperare la competenza da GitHub",
    "invalidRef": "Ref non valido — usa owner/repo/path/to/file.md",
    "couldNotFetchFile": "Impossibile recuperare il file da GitHub",
    "pageTitle": "Nuova Competenza",
    "createTab": "Crea",
    "importTab": "Importa da GitHub",
    "nameLabel": "Nome *",
    "namePlaceholder": "code-review",
    "versionLabel": "Versione",
    "descriptionLabel": "Descrizione",
    "descriptionPlaceholder": "Breve descrizione di cosa fa questa competenza",
    "contentLabel": "Contenuto *",
    "categoriesLabel": "Categorie",
    "extraTagsLabel": "Tag extra",
    "optional": "(opzionale)",
    "visibilityLabel": "Visibilità",
    "pasteAnyOf": "Incolla uno di questi:",
    "pasteUrlPlaceholder": "Incolla un URL di GitHub o owner/repo/path…",
    "searchSpecificDirectory": "Cerca in una directory specifica",
    "customSearchPlaceholder": "ad es. agents/ o .claude/skills",
    "readyToImport": "Pronto per l'importazione",
    "categoriesLabelImport": "Categorie",
    "optionalAddsToImportedTags": "(opzionale, aggiunge ai tag importati)",
    "visibilityAfterImport": "Visibilità dopo l'importazione",
    "importing": "Importazione in corso…",
    "importButton": "Importa Competenza",
    "contentPlaceholder": "# Contenuto Competenza\n\nDescrivi le istruzioni della competenza, i prompt o la configurazione qui…",
    "creating": "Creazione…",
    "createButton": "Crea Competenza",
    "discovering": "Scoperta…",
    "loading": "Caricamento…",
    "discoverButton": "Scopri",
    "previewButton": "Anteprima",
    "searchButton": "Cerca",
    "notFoundSpecifyPath": "Non trovato? Specifica il percorso →",
    "importButtonLabel": "Importa Competenza",
    "repoUrl": "URL del repository",
    "directFileUrl": "URL diretto del file"
  },
  "siloTimeline": {
    "mapNotGenerated": "Mappa Intelligence Piattaforma non ancora generata",
    "triggerSyncToBuild": "Attiva una sincronizzazione per generarla.",
    "builtFromSnapshots": "Costruita dai tuoi snapshot giornalieri — inviamone alcuni con `joyia memory sync git-log`, o allega un'integrazione server-side.",
    "platformMap": "Mappa Intelligence Piattaforma",
    "historicalRecord": "Registro Storico",
    "noSnapshotsYet": "Nessuno snapshot giornaliero ancora. Attiva una sincronizzazione per iniziare l'acquisizione.",
    "noSnapshotsPush": "Nessuno snapshot giornaliero ancora. Invialo dal tuo progetto con `joyia memory sync git-log`.",
    "seeded": "Inizializzati {{count}} elementi della timeline",
    "seedTestData": "Inizializza dati di test",
    "dailySnapshots": "Snapshot Giornalieri",
    "windowDesc": "(finestra mobile di 30 giorni, i dati precedenti vengono compattati nel Registro Storico)",
    "timelineExplorer": "Esplora Timeline",
    "updatedAgo": "Aggiornato {{time}} fa",
    "noContentYet": "Nessun contenuto ancora."
  },
  "syncConfig": {
    "dangerZone": "Zona a rischio",
    "resetStoreTitle": "Azzera l'archivio e riavvia",
    "resetStoreDesc": "Elimina tutti gli elementi importati e azzera i segnaposto di sincronizzazione. La configurazione della sorgente viene conservata. La prossima sincronizzazione reimporterà tutto da zero.",
    "resetRestartBtn": "Azzera e riavvia",
    "areYouSure": "Sei sicuro?",
    "resetting": "Azzeramento in corso…",
    "yesReset": "Sì, azzera",
    "rebuildIndexTitle": "Ricostruisci l'indice di ricerca",
    "rebuildIndexDesc": "Ricostruisce l'albero di ricerca semantica dagli elementi già presenti in questo silo. Non viene eliminato nulla e nessun contenuto va perduto. Usalo se la ricerca non restituisce nulla, oppure se chiedendo qualcosa a questo silo ti risponde che «non è ancora ricercabile» mentre non è in corso alcuna sincronizzazione: quello stato non si risolve da sé. Vale la pena eseguirlo anche dopo un'importazione massiccia.",
    "indexing": "Indicizzazione in corso…",
    "queuing": "In coda…",
    "rebuildIndexBtn": "Ricostruisci l'indice",
    "tokenHelp": {
      "confluence": "Crea un token API Atlassian",
      "jira": "Crea un token API Atlassian",
      "openwebui": "Crea una chiave API su chat.joyia.p7s1.io (Settings → Account)",
      "gitlab": "Crea un token di accesso personale GitLab",
      "github": "Crea un token di accesso personale GitHub",
      "slack": "Crea un'app Slack e un token del bot",
      "teams": "Azure Portal → App registrations → Certificates & secrets",
      "sharepoint": "Azure Portal → App registrations → Certificates & secrets",
      "gdrive": "Google Cloud Console → Service Accounts → Keys"
    },
    "heading": "Configurazione della sincronizzazione",
    "syncHistory": "Cronologia delle sincronizzazioni",
    "addSource": "Aggiungi una sorgente",
    "addIngestSource": "Aggiungi una sorgente di importazione",
    "docAndTimelineConnectors": "Connettori di documenti e cronologia",
    "phBaseUrl": "URL di base",
    "phApiToken": "Token API",
    "phEmail": "Email",
    "phGitlabUrl": "URL di base di GitLab (ad es. https://gitlab.com)",
    "phPersonalAccessToken": "Token di accesso personale",
    "phProjectPaths": "Chiavi o percorsi dei progetti (separati da virgola, ad es. mygroup/myrepo)",
    "phEnvironments": "Ambienti (facoltativi, separati da virgola, ad es. production,staging)",
    "phDatadogApiKey": "Chiave API di Datadog",
    "createDatadogApiKey": "Crea una chiave API di Datadog ↗",
    "phDatadogAppKey": "Chiave applicativa di Datadog",
    "createDatadogAppKey": "Crea una chiave applicativa di Datadog ↗",
    "phDatadogSiteDefault": "Site (predefinito: datadoghq.eu)",
    "phServices": "Servizi (facoltativi, separati da virgola)",
    "phFilterTags": "Tag di filtro (facoltativi, ad es. env:production)",
    "phGithubPatPlain": "Token di accesso personale GitHub",
    "phRepositories": "Repository (separati da virgola, ad es. owner/repo, owner/repo2)",
    "phPagerdutyKey": "Chiave REST API di PagerDuty",
    "phServiceIds": "ID dei servizi (facoltativi, separati da virgola)",
    "phTeamIdsOptional": "ID dei team (facoltativi, separati da virgola)",
    "phBotTokenXoxb": "Token OAuth del bot (xoxb-…)",
    "phChannelIdsLong": "ID dei canali (separati da virgola, ad es. C0123456789, C9876543210)",
    "phWorkspaceLong": "Nome dello spazio di lavoro (facoltativo, ad es. Acme Engineering)",
    "phTenantId": "ID del tenant Azure AD",
    "phClientId": "ID client della registrazione dell'app",
    "phClientSecret": "Client secret",
    "phTeamIds": "ID dei team (separati da virgola)",
    "phSiteId": "ID del site (oppure lascia vuoto e usa l'URL del site qui sotto)",
    "phSiteUrl": "URL del site (ad es. contoso.sharepoint.com:/sites/Engineering)",
    "resourceType": "Tipo di risorsa:",
    "documentLibrary": "Raccolta di documenti",
    "sharepointList": "Elenco SharePoint",
    "phListId": "ID dell'elenco",
    "phDriveIdLong": "ID del drive (facoltativo — per impostazione predefinita la raccolta di documenti del site)",
    "phFolderPathLong": "Percorso della cartella (facoltativo — sottocartella a cui limitare la sincronizzazione)",
    "phServiceAccountEmail": "Email dell'account di servizio",
    "phPrivateKeyLong": "Chiave privata (incolla la chiave PEM completa dal JSON dell'account di servizio)",
    "phFolderIdsLong": "ID delle cartelle (separati da virgola — condividi ogni cartella con l'email dell'account di servizio)",
    "entireSpaces": "Spazi interi",
    "phSpaceKeysLong": "Chiavi degli spazi (separate da virgola, ad es. ENG, DOCS)",
    "importsEveryPage": "Importa ogni pagina di ciascuno spazio elencato.",
    "pageTrees": "Alberi di pagine",
    "phPageIds": "ID delle pagine (separati da virgola)",
    "phProjectKeysLong": "Chiavi dei progetti (separate da virgola, ad es. ENG, OPS)",
    "phIssueTypesLong": "Tipi di ticket (facoltativi, separati da virgola, ad es. Bug, Story)",
    "phJqlLong": "JQL personalizzato (facoltativo — sovrascrive le chiavi dei progetti)",
    "scheduleAuto": "Pianifica la sincronizzazione automatica",
    "every6h": "Ogni 6 ore",
    "every12h": "Ogni 12 ore",
    "every24h": "Ogni 24 ore",
    "every48h": "Ogni 48 ore",
    "cancel": "Annulla",
    "titleStopSync": "Interrompi la sincronizzazione (il lotto in corso viene completato)",
    "titlePreviewPage": "Anteprima della pagina modificata più di recente",
    "titleDiscoverCount": "Scopri il numero reale di pagine impaginando Confluence",
    "extractingWithAi": "Estrazione e riepilogo della pagina con l'IA…",
    "openInConfluence": "Apri in Confluence ↗",
    "looksGoodStartSync": "Va bene — avvia la sincronizzazione completa",
    "close": "Chiudi",
    "tryAnotherPage": "Prova un'altra pagina",
    "phSpaceKeysShort": "Chiavi degli spazi (separate da virgola)",
    "phProjectKeysShort": "Chiavi dei progetti (separate da virgola)",
    "phIssueTypesShort": "Tipi di ticket (facoltativi)",
    "phJqlShort": "JQL personalizzato (facoltativo)",
    "phAccessTokenKeep": "Token di accesso (lascia vuoto per mantenere quello esistente)",
    "phApiKeyKeep": "Chiave API (lascia vuoto per mantenere quella esistente)",
    "phAppKeyKeep": "Chiave applicativa (lascia vuoto per mantenere quella esistente)",
    "phDatadogSite": "Site (ad es. datadoghq.eu)",
    "phGithubPat": "Token di accesso personale GitHub (lascia vuoto per mantenere quello esistente)",
    "phRestApiKey": "Chiave REST API (lascia vuoto per mantenere quella esistente)",
    "phBotToken": "Token OAuth del bot (lascia vuoto per mantenere quello esistente)",
    "phChannelIds": "ID dei canali (separati da virgola)",
    "phWorkspaceShort": "Nome dello spazio di lavoro (facoltativo)",
    "phTenantIdKeep": "ID del tenant Azure AD (lascia vuoto per mantenere quello esistente)",
    "phClientIdKeep": "ID client della registrazione dell'app (lascia vuoto per mantenere quello esistente)",
    "phClientSecretKeep": "Client secret (lascia vuoto per mantenere quello esistente)",
    "noSitesFound": "Nessun site trovato per questa connessione.",
    "phDriveIdShort": "ID del drive (facoltativo)",
    "phFolderPathShort": "Percorso della cartella (facoltativo)",
    "browseFolders": "Sfoglia le cartelle",
    "useThisFolder": "Usa questa cartella",
    "loading": "Caricamento…",
    "emptyFolder": "Cartella vuota.",
    "phServiceAccountEmailKeep": "Email dell'account di servizio (lascia vuoto per mantenere quella esistente)",
    "phPrivateKeyKeep": "Chiave privata (lascia vuoto per mantenere quella esistente)",
    "phFolderIdsShort": "ID delle cartelle (separati da virgola)",
    "enableWebhook": "Attiva l'importazione via webhook",
    "noIngestSources": "Nessuna sorgente di importazione configurata finora",
    "addOpenwebuiOutputBtn": "Aggiungi un'uscita OpenWebUI",
    "addOpenwebuiOutput": "Aggiungi un'uscita OpenWebUI",
    "phOpenwebuiUrl": "URL di base (ad es. https://chat.joyia.p7s1.io)",
    "phApiKey": "Chiave API",
    "phKnowledgeBaseIds": "ID delle basi di conoscenza (uno per riga o separati da virgola)",
    "addOutput": "Aggiungi un'uscita",
    "titleTriggerOutput": "Avvia subito la sincronizzazione dell'uscita",
    "noOutputs": "Nessuna uscita configurata finora",
    "deleteSilo": "Elimina questo silo",
    "deleteSiloBtn": "Elimina il silo",
    "thisIsPermanent": "L'operazione è definitiva!",
    "deleting": "Eliminazione in corso…",
    "testing": "Test in corso…",
    "testConnection": "Verifica la connessione",
    "pagerDutyPath": "Nel tuo account PagerDuty: {{path}}",
    "recommendedOwnAccount": "Consigliato: collegati con il tuo account Microsoft (non serve un amministratore Azure)",
    "orAppOnly": "Oppure configura manualmente l'autenticazione app-only (richiede un amministratore Azure AD che conceda l'accesso Sites.Selected):",
    "copyListId": "Obbligatorio. Copia l'ID dell'elenco da SharePoint o da Microsoft Graph Explorer.",
    "askToVerify": "Fai una domanda su questa pagina per verificare che l'IA l'abbia capita:",
    "fetchingConfluence": "Recupero della pagina da Confluence e riassunto con l'IA…",
    "pickSiteFirst": "Scegli prima un sito qui sopra oppure inserisci un ID o URL del sito.",
    "deleteSiloWarning": "Elimina definitivamente il silo, tutti gli elementi, la configurazione di sincronizzazione e i nodi del grafo di conoscenza. L'operazione non può essere annullata.",
    "raptorRebuildQueued": "Ricostruzione indice RAPTOR in coda – verificare la Cronologia sincronizzazione per i progressi",
    "rebuildFailed": "Ricostruzione non riuscita: {{error}}",
    "syncCancelled": "Sincronizzazione annullata – il batch corrente terminerà e quindi si fermerà",
    "cancelFailed": "Annullamento non riuscito: {{error}}",
    "resetComplete": "Ripristino completato – {{deletedItems}} elementi eliminati, {{sourcesReset}} fonte(i) cancellate. Attiva una sincronizzazione completa per reinserire.",
    "resetFailed": "Ripristino non riuscito: {{error}}",
    "syncFailed": "Sincronizzazione non riuscita: {{error}}",
    "outputSyncQueued": "Sincronizzazione output in coda",
    "outputSyncFailed": "Sincronizzazione output non riuscita: {{error}}",
    "sourceAdded": "Fonte aggiunta",
    "failedToAddSource": "Impossibile aggiungere la fonte: {{error}}",
    "sourceRemoved": "Fonte rimossa",
    "failedToRemoveSource": "Impossibile rimuovere la fonte: {{error}}",
    "sourceUpdated": "Fonte aggiornata",
    "failedToUpdateSource": "Impossibile aggiornare la fonte: {{error}}",
    "enterBaseUrlAndApiKeyFirst": "Inserisci prima l'URL di base e la chiave API.",
    "connectedFoundKbsWithNames": "Connesso! {{count}} base(i) di conoscenza trovate: {{names}}",
    "connectedFoundKbs": "Connesso! {{count}} base(i) di conoscenza trovate.",
    "connectionFailed": "Connessione non riuscita: {{error}}",
    "outputAdded": "Output aggiunto",
    "failedToAddOutput": "Impossibile aggiungere l'output: {{error}}",
    "outputRemoved": "Output rimosso",
    "failedToRemoveOutput": "Impossibile rimuovere l'output: {{error}}",
    "discoverFailed": "Rilevamento non riuscito: {{error}}",
    "previewFailed": "Anteprima non riuscita: {{error}}",
    "askFailed": "Richiesta non riuscita: {{error}}",
    "descSpaces": "spazi: {{keys}}",
    "descProjects": "progetti: {{keys}}",
    "descJql": "JQL: {{jql}}…",
    "descServices": "servizi: {{services}}",
    "descRepos": "repository: {{repos}}",
    "descTeams": "team: {{teams}}",
    "descChannels": "canali: {{channels}}",
    "descSyncedViaCli": "Sincronizzato tramite Joyia CLI (joyia memory sync)",
    "descList": "elenco: {{listId}}",
    "descListNoId": "elenco (nessun ID elenco impostato)",
    "descFolder": "cartella: {{folderPath}}",
    "descNoSiteConfigured": "Nessun sito configurato",
    "descFolders": "cartelle: {{folders}}",
    "descNoFoldersConfigured": "Nessuna cartella configurata",
    "descNoUrlConfigured": "Nessun URL configurato",
    "disableScheduledSync": "Disabilita sincronizzazione pianificata",
    "enableScheduledSync": "Abilita sincronizzazione pianificata",
    "schedule": "pianificazione",
    "cancelEdit": "Annulla modifica",
    "editSource": "Modifica fonte",
    "incrementalSyncTitle": "Sincronizzazione incrementale (solo modifiche)",
    "fullSyncTitle": "Sincronizzazione completa",
    "syncAlreadyRunning": "Sincronizzazione già in corso",
    "forceFullResync": "Forza risincronizzazione completa (tutte le pagine)",
    "rawExcerptAiUnavailable": "Estratto grezzo (IA non disponibile)",
    "aiSummary": "Riepilogo IA",
    "phAskPageQuestion": "ad es. Qual è l'argomento principale di questa pagina?",
    "webhookUrlCopied": "URL webhook copiato",
    "copy": "Copia",
    "yesDelete": "Sì, elimina"
  },
  "connector": {
    "confluenceDesc": "Pagine e spazi",
    "jiraDesc": "Ticket e progetti",
    "openwebuiDesc": "Base di conoscenza",
    "gitlabDesc": "Pipeline, merge request e deploy",
    "datadogDesc": "Monitor ed eventi",
    "githubDesc": "Actions, pull request e release",
    "pagerdutyDesc": "Incidenti e reperibilità",
    "slackDesc": "Riepiloghi dei canali e discussioni",
    "teamsDesc": "Attività dei canali",
    "local": "Locale / CLI",
    "localDesc": "File di progetto tramite la CLI joyia",
    "sharepointDesc": "Raccolte di documenti",
    "gdriveDesc": "Docs, Sheets e Slides",
    "confluence": "Confluence",
    "jira": "Jira",
    "openwebui": "OpenWebUI",
    "gitlab": "GitLab",
    "datadog": "Datadog",
    "github": "GitHub",
    "pagerduty": "PagerDuty",
    "slack": "Slack",
    "teams": "MS Teams",
    "sharepoint": "SharePoint",
    "gdrive": "Google Drive"
  },
  "siloTree": {
    "syncing": "Sincronizzazione…",
    "treeStats": "Statistiche dell'albero",
    "totalNodes": "Nodi totali",
    "layers": "Livelli",
    "leafNodes": "Nodi foglia",
    "summaries": "Riepiloghi",
    "legend": "Legenda",
    "leafChunk": "Blocco foglia",
    "treeExplorer": "Esplora albero",
    "loadingTree": "Caricamento dell'albero…",
    "failedToLoad": "Non è stato possibile caricare l'albero",
    "retry": "Riprova",
    "noTreeYet": "Nessun albero RAPTOR costruito finora",
    "triggerSync": "Avvia una sincronizzazione per costruire l'indice semantico.",
    "goToSilo": "Vai al silo",
    "summarisedFrom_one": "Riepilogato da {{count}} nodo",
    "summarisedFrom_other": "Riepilogato da {{count}} nodi"
  },
  "createItem": {
    "addItem": "Aggiungi un elemento di conoscenza",
    "title": "Titolo *",
    "phTitle": "Titolo dell'elemento",
    "content": "Contenuto",
    "phContent": "Markdown supportato…",
    "knowledgeType": "Tipo di conoscenza",
    "typeAuto": "Rilevamento automatico",
    "typeFactual": "Fattuale — documenti di riferimento, fatti stabili",
    "typeProcedural": "Procedurale — runbook, guide pratiche",
    "typeTemporal": "Temporale — eventi legati al tempo, istantanee",
    "typeRelational": "Relazionale — dipendenze, architettura",
    "typeContextual": "Contestuale — stato attuale, incidenti",
    "typeSocial": "Sociale — struttura del team, responsabilità",
    "typePolicy": "Normativo — conformità, SLA, governance",
    "typeMeta": "Meta — riepiloghi, indici",
    "tags": "Tag (separati da virgola)",
    "suggestTags": "Suggerisci i tag con l'IA a partire da titolo e contenuto"
  },
  "createSilo": {
    "startingLayout": "Struttura iniziale",
    "change": "Cambia",
    "tags": "Tag (separati da virgola)",
    "publicSilo": "Silo pubblico",
    "publicSiloDesc": "Tutte le persone della tua organizzazione possono leggere questo silo",
    "guardrailProfiles": "Profili di protezione",
    "guardrailDesc": "Si applica a tutte le chiamate LLM che elaborano il contenuto di questo silo",
    "cancel": "Annulla",
    "creating": "Creazione…",
    "create": "Crea il silo"
  },
  "errorBoundary": {
    "somethingWrong": "Qualcosa è andato storto",
    "unexpected": "Si è verificato un errore inatteso",
    "tryAgain": "Riprova",
    "goHome": "Vai alla home"
  },
  "siloShare": {
    "private": "Privato",
    "privateDesc": "Solo tu puoi accedere",
    "restricted": "Limitato",
    "restrictedDesc": "Le persone che inviti",
    "tribe": "Tribe",
    "tribeDesc": "Tutti i membri di un tribe",
    "orgVisible": "Visibile all'organizzazione",
    "orgVisibleDesc": "Chiunque nella tua organizzazione",
    "shareSilo": "Condividi il silo",
    "controlAccess": "Decidi chi può accedere a questo silo di conoscenza.",
    "visibility": "Visibilità",
    "selectTribes": "Scegli i tribe che possono vedere questo silo",
    "noTribes": "Nessun tribe disponibile",
    "selectAtLeastOne": "Scegli almeno un tribe per salvare",
    "pendingRequests": "Richieste in attesa",
    "approve": "Approva",
    "deny": "Rifiuta",
    "peopleWithAccess": "Persone con accesso",
    "emailAddress": "Indirizzo email",
    "roleViewer": "Lettura",
    "roleEditor": "Modifica",
    "invite": "Invita",
    "youOwner": "Tu (proprietario)",
    "owner": "Proprietario",
    "removeMember": "Rimuovi il membro",
    "noMembers": "Ancora nessun altro membro. Invita qualcuno qui sopra."
  },
  "globalChat": {
    "suggestConnectSource": "Come collego una sorgente?",
    "suggestSiloVsSkill": "Che differenza c’è tra un silo e una skill?",
    "askAi": "Chiedi all’IA",
    "askKnowledgeBase": "Interroga la tua base di conoscenza",
    "liveAccess": "Accesso in tempo reale:",
    "askAboutKf": "Chiedi su Knowledgeflow",
    "verifyBeforeActing": "Le risposte provengono dalla documentazione: verifica sempre prima di agire.",
    "closeChat": "Chiudi la chat",
    "phAskKf": "Chiedi qualcosa su Knowledgeflow… (Invio per inviare)",
    "clearConversation": "Cancella la conversazione",
    "yourKnowledge": "La tua conoscenza",
    "help": "Aiuto",
    "thisSilo": "Questo silo",
    "allSilos": "Tutti i silo",
    "searchingWithinThisSilo": "Ricerca all'interno di questo silo",
    "searchingAcrossAllSilos": "Ricerca in tutti i silo",
    "suggestMonitorsAlerting": "Quali monitor sono attivi?",
    "suggestRecentEvents": "Mostra eventi recenti",
    "suggestOpenMergeRequests": "Mostra merge request aperti",
    "suggestRecentPipelineStatus": "Stato pipeline recente",
    "suggestIssuesInProgress": "Quali issue sono in corso?",
    "suggestTopicsCovered": "Quali argomenti sono coperti?",
    "suggestFindRecentItems": "Trova elementi recenti",
    "suggestSummarizeSilo": "Riepiloga questo silo",
    "phAskAllSilos": "Fai una domanda in tutti i silo… (Invio per inviare)",
    "contentPolicies": "Politiche contenuti",
    "contentPoliciesActive": "Politiche contenuti (attive)",
    "answerFromDocs": "Rispondo dalla documentazione di Knowledgeflow."
  },
  "bundledFiles": {
    "heading": "File inclusi",
    "phContents": "Contenuto del file…"
  },
  "skillCard": {
    "viewSkill": "Vedi la skill"
  },
  "carousel": {
    "prevSlide": "Diapositiva precedente",
    "nextSlide": "Diapositiva successiva"
  },
  "agentElement": {
    "maxTurns": "Turni max"
  },
  "collab": {
    "settings": "Impostazioni di Collab",
    "approvalMode": "Modalità di approvazione",
    "maxTurnsPerPersona": "Turni massimi per persona",
    "resetCounter": "Reimposta il contatore dei turni",
    "reset": "Reimposta"
  },
  "connectionStatus": {
    "offline": "Nessuna connessione. I dati non possono essere aggiornati finché non torni online.",
    "reload": "Ricarica"
  },
  "helpAnswer": {
    "sources": "Fonti"
  },
  "helpWidget": {
    "clearAria": "Cancella la conversazione",
    "clear": "Cancella la conversazione",
    "closeAria": "Chiudi la guida",
    "reading": "Lettura della documentazione…",
    "verifyNote": "Le risposte provengono dalla documentazione: verifica sempre prima di agire.",
    "productHelp": "Aiuto {{product}}",
    "productHelpDrag": "Aiuto {{product}} — trascinare per spostare",
    "answersFromDocs": "Risposte dalla documentazione {{product}}",
    "askAbout": "Domande su {{product}}",
    "askAboutDetail": "Rispondo dalla documentazione {{product}} e posso indicarti il posto giusto.",
    "askAboutPlaceholder": "Domande su {{product}}…",
    "notAvailableYet": "L'aiuto non è ancora disponibile qui.",
    "somethingWentWrong": "Qualcosa è andato storto (HTTP {{status}}).",
    "requestFailed": "La richiesta non è riuscita.",
    "couldNotRunAction": "Non è stato possibile {{action}}."
  },
  "citation": {
    "prevAria": "Precedente",
    "nextAria": "Successivo"
  },
  "installPrompt": {
    "notNowAria": "Non ora",
    "iosPath": "Share → Add to Home Screen",
    "showMeHow": "Mostrami come",
    "install": "Installa"
  },
  "messageEditor": {
    "cancel": "Annulla"
  },
  "message": {
    "copy": "Copia il messaggio",
    "regenerate": "Rigenera la risposta",
    "edit": "Modifica il messaggio",
    "goodResponse": "Buona risposta",
    "poorResponse": "Risposta scadente"
  },
  "plan": {
    "toggle": "Mostra/nascondi il piano"
  },
  "promptInput": {
    "removeAttachment": "Rimuovi l'allegato"
  },
  "reasoning": {
    "thinking": "Sto pensando…",
    "thoughtFor": "Ha pensato per alcuni secondi",
    "thoughtForSeconds_one": "Ha pensato per {{count}} secondo",
    "thoughtForSeconds_other": "Ha pensato per {{count}} secondi"
  },
  "tool": {
    "streaming": "In streaming",
    "running": "In esecuzione",
    "approvalRequired": "Richiede approvazione",
    "approved": "Approvato",
    "completed": "Completato",
    "denied": "Rifiutato",
    "error": "Errore",
    "pending": "In attesa"
  }
}
